import React, { useState, useEffect } from "react";
import { getAuthHeader } from "../../api/authToken.js";
import "../../styles/App.css";
import GroupLabel from "../../components/GroupLabel.js";

const ArchivedStudentsPage = () => {
  const [students, setStudents] = useState([]);
  const [filteredStudents, setFilteredStudents] = useState([]);
  const [search, setSearch] = useState("");
  const [group, setGroup] = useState("");
  const [minViolations, setMinViolations] = useState("");
  const [rooms, setRooms] = useState([]);
  const [selectedRoom, setSelectedRoom] = useState({});
  const API = process.env.REACT_APP_API_BASE;
  const [sortConfig, setSortConfig] = useState({
    key: "rating",
    direction: "desc",
  });

  useEffect(() => {
    fetchStudents();
    fetchRooms();
  }, []);

  const fetchStudents = () => {
    fetch(`${API}/api/archived-students`, {
      headers: { Authorization: getAuthHeader() },
    })
      .then((res) => res.json())
      .then((data) => {
        setStudents(data);
        setFilteredStudents(data);
        setSelectedRoom({});
      })
      .catch((err) => {
        console.error("Помилка завантаження студентів:", err);
        setStudents([]);
        setFilteredStudents([]);
      });
  };

  const fetchRooms = () => {
    fetch(`${API}/api/available-rooms`, {
      headers: { Authorization: getAuthHeader() },
    })
      .then((res) => res.json())
      .then((data) => setRooms(data))
      .catch((err) => console.error("Помилка завантаження кімнат:", err));
  };

  useEffect(() => {
    let filtered = students;

    if (search.trim() !== "") {
      filtered = filtered.filter((student) =>
        student.pib.toLowerCase().includes(search.toLowerCase())
      );
    }

    if (group.trim() !== "") {
      filtered = filtered.filter((student) =>
        (student.group || "").toLowerCase().includes(group.toLowerCase())
      );
    }

    if (minViolations !== "") {
      filtered = filtered.filter(
        (student) => student.violations >= Number(minViolations)
      );
    }

    setFilteredStudents(filtered);
  }, [search, group, minViolations, students]);

  const restoreStudent = (id) => {
    const room = selectedRoom[id];
    if (!room) {
      alert("Будь ласка, виберіть кімнату для переселення студента.");
      return;
    }

    if (
      window.confirm(
        "Ви впевнені, що хочете повернути студента до основної таблиці?"
      )
    ) {
      fetch(`${API}/api/restore-student/${id}`, {
        method: "POST",
        headers: {
          Authorization: getAuthHeader(),
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ room_id: room }),
      })
        .then((res) => res.json())
        .then((data) => {
          alert(data.message);
          fetchStudents();
        })
        .catch((err) => console.error("Помилка відновлення студента:", err));
    }
  };

  const handleRoomChange = (id, value) => {
    setSelectedRoom((prev) => ({ ...prev, [id]: value }));
  };

  const sortData = (data, config) => {
    const sortedData = [...data].sort((a, b) => {
      if (a[config.key] < b[config.key]) {
        return config.direction === "asc" ? -1 : 1;
      }
      if (a[config.key] > b[config.key]) {
        return config.direction === "asc" ? 1 : -1;
      }
      return 0;
    });
    return sortedData;
  };

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
    setStudents((prevStudents) => sortData(prevStudents, { key, direction }));
  };

  return (
    <div className="page-container">
      <h2 className="text-header">Архівні студенти</h2>

      <div className="input-component form-container">
        <input
          className="input-component-with-border input-block"
          type="text"
          placeholder="Пошук за ПІБ"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <input
          className="input-component-with-border input-block"
          type="text"
          placeholder="Група"
          value={group}
          onChange={(e) => setGroup(e.target.value)}
        />
        <input
          className="input-component-with-border input-block"
          type="number"
          placeholder="Мін. кількість порушень"
          value={minViolations}
          onChange={(e) => setMinViolations(e.target.value)}
        />
      </div>

      {filteredStudents.length > 0 ? (
        <>
          <table className="table">
            <thead>
              <tr>
                <th className="table-header" onClick={() => handleSort("pib")}>
                  ПІБ{" "}
                  {sortConfig.key === "pib"
                    ? sortConfig.direction === "asc"
                      ? "↑"
                      : "↓"
                    : "↑↓"}
                </th>
                <th
                  className="table-header"
                  onClick={() => handleSort("group")}
                >
                  Група{" "}
                  {sortConfig.key === "group"
                    ? sortConfig.direction === "asc"
                      ? "↑"
                      : "↓"
                    : "↑↓"}
                </th>
                <th
                  className="table-header"
                  onClick={() => handleSort("violations")}
                >
                  Порушень{" "}
                  {sortConfig.key === "violations"
                    ? sortConfig.direction === "asc"
                      ? "↑"
                      : "↓"
                    : "↑↓"}
                </th>
                <th
                  className="table-header"
                  onClick={() => handleSort("can_be_rehoused")}
                >
                  Переселення{" "}
                  {sortConfig.key === "can_be_rehoused"
                    ? sortConfig.direction === "asc"
                      ? "↑"
                      : "↓"
                    : "↑↓"}
                </th>
                <th className="table-header">Дія</th>
              </tr>
            </thead>
            <tbody>
              {filteredStudents.map((student) => (
                <tr key={student.id}>
                  <td className="table-content">{student.pib}</td>
                  <td className="table-content"><GroupLabel group={student.group} /></td>
                  <td className="table-content">{student.violations}</td>
                  <td className="table-content">
                    {student.can_be_rehoused ? (
                      <select
                        className="input-component-with-border"
                        value={selectedRoom[student.id] || ""}
                        onChange={(e) =>
                          handleRoomChange(student.id, e.target.value)
                        }
                      >
                        <option value="">Виберіть кімнату</option>
                        {rooms.map((room) => (
                          <option key={room.id} value={room.id}>
                            {room.dormitory_name} - {room.room_number} (Місць:{" "}
                            {room.free_beds})
                          </option>
                        ))}
                      </select>
                    ) : (
                      "Ні"
                    )}
                  </td>
                  <td className="table-content">
                    <button
                      onClick={() => restoreStudent(student.id)}
                      disabled={!student.can_be_rehoused}
                      className="restore-button"
                    >
                      Відновити
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      ) : (
        <h2 className="no-data">Немає студентів/даних</h2>
      )}
    </div>
  );
};

export default ArchivedStudentsPage;
